import React, { useContext, useState, useEffect } from 'react';
import {
  Box,
  Grid,
  Dialog,
  Button,
  TextField,
  Typography,
  IconButton,
  DialogTitle,
  DialogContent
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useForm, Controller } from 'react-hook-form';
import { withStyles } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import AutocompleteInput from 'components/CustomInputs/AutocompleteInput';
import { I18nContext } from 'translations';
import { modalMessage } from 'utils';
import { useStateValue } from 'context/store';
import { editAddress } from 'context/booking/actions';
import Loading from 'components/Loading';
import { useHistory } from 'react-router-dom';
import styles from '../../Tables/styleTableFilters';

function ModalEditAddress ({
  open,
  closeModal,
  city,
  setCity,
  id,
  location,
  secondaryAddress,
  isOrigin
}) {
  const { translate } = useContext(I18nContext);
  const [loading, setLoading] = useState(false);
  const [, dispatch] = useStateValue();
  const [address, setAddress] = useState(location ? location : '');
  const history = useHistory();
  const { handleSubmit, control, reset } = useForm()

  useEffect(() => {
    if (open) {
      setAddress(location ? location : '');
      reset({
        secondary_address: secondaryAddress || ''
      });
    }
  }, [open, location, secondaryAddress, reset]);

  const messageOk = () => {
    setLoading(false);
    modalMessage(
      '',
      translate('savedSuccessfully'),
      'success',
      translate('accept'),
      true
    ).then(() => {
      closeModal();
      history.go()
    });
  };

  const submit = async values => {
    setLoading(true);
    const callback = await editAddress(dispatch, id, {...values, address, }, isOrigin)
    callback.status ? messageOk() : setLoading(false)
  }

  const handleSuggest = (info) => {
    setAddress(info);
  };

  return (
    <Dialog
      open={open}
      aria-describedby="alert-dialog-description"
      maxWidth="md"
      fullWidth
    >
      <DialogTitle disableTypography>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" style={{ color: '#7C3AED', fontWeight: 'bold' }}>
            {translate('app.express.updateAddress')}
          </Typography>
          <IconButton onClick={closeModal} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent style={{ padding: '10px 40px 40px' }}>
        {loading && <Loading />}
        <form onSubmit={handleSubmit(submit)} noValidate>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="subtitle2" style={{ color: '#7C3AED', fontWeight: 'bold', marginBottom: 10 }}>
                {translate('app.express.address')}
              </Typography>
              <Grid container spacing={2}>
                <Grid item sm={12} md={6}>
                  {city && (
                    <Autocomplete
                      id="cities"
                      options={city ? [city] : [{ id: 'none', name: translate('app.express.noCities') }]}
                      autoHighlight
                      getOptionLabel={(option) => option.name || option}
                      renderInput={(params) => <TextField {...params} variant="outlined" size="small" placeholder={translate('app.express.city')} />}
                      value={city}
                      onChange={(event, newValue) => {
                        event.stopPropagation();
                        setCity && setCity(newValue);
                      }}
                      disabled={true}
                    />
                  )}
                </Grid>
                <Grid item sm={12} md={6}>
                  <AutocompleteInput
                    title={translate('app.express.address')}
                    name="address"
                    address={address && address}
                    cityId={city?._id}
                    pos={{ lat: city?.location?.lat, lon: city?.location?.lon }}
                    focus
                    handleChange={handleSuggest}
                  />
                </Grid>
                <Grid item sm={12} md={6}>
                  <Controller
                    name="secondary_address"
                    control={control}
                    defaultValue={secondaryAddress || ""}
                    render={({ onChange, value }) => (
                      <TextField
                        size="small"
                        variant="outlined"
                        placeholder={translate('app.express.supplementaryAddress')}
                        fullWidth
                        value={value}
                        onChange={onChange}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} className="text-right">
              <Button
                variant="contained"
                type="submit"
                color="primary"
                disabled={(address === undefined && address?.lat === undefined)}
                style={{ borderRadius: '25px', textTransform: 'none', padding: '8px 30px' }}
              >
                {translate('save')}
              </Button>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  )
}

export default withStyles(styles)(ModalEditAddress);